const DEFAULT_API_BASE_URL = 'https://api.connectei3.com';

export const API_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_API_BASE_URL;

export const buildApiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('authToken')}`,
});
